import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { configurationProfileSchema } from '../schemas/configuration-profile.schema';
import { fromFetch } from 'rxjs/fetch';

/**
 * Requests a specific Configuration Profile
 * @param id The ID of the Configuration Profile being requested
 * @returns The Configuration Profile
 */
export function getConfigurationProfilesId(this: unknown, id: number) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${fleetEnvironment.resolve(this).configurationProfilesUrl}/${id}`,
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(selectData(configurationProfileSchema));
}
